const dev = [
  {
    front: [
      "HTML5",
      "CSS",
      "Bootstrap",
      "Javascript",
      "JSX",
      "jQuery",
      "GraphQL",
      "React",
      "React Hooks",
      "Handlebars"
    ]
  },
  {
    back: [
      "indexDB",
      "Postman / Insomnia",
      "AJAX / Fetch",
      "Node.js",
      "Express.js",
      "Express Sessions",
      "MySQL",
      "Sequelize ORM",
      "Mongo DB",
      "Mongoose ODM"
    ]
  }
];

const idk = [
  "Serverside Templating (Handlebars.js)",
  "Passport / Express Sessions",
  "JSON",
  "JSON Web Tokens",

  "Git", //source management
  "GitHub", //project management
  "Heroku", //project deployment

  "Imperative Programming", //changing state by issuing instructions - js
  "Declarative Programming", //creating effects without specifying how -- html
  "Pseudocode",
  "ES6", //version of js

  "Frontend Development",

  "Backend Development",
  "Relational Databases",
  "Non-Relational Databases",
  "Web API",
  "Server Side API",
  "Rest API",

  "Full Stack Development",
  "Object-oriented Programming (OOP)",
  "Data Structures and Algorithms",
  "Problem-Solving",
];

export default dev